import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  AuthError,
  Chart,
  Check,
  ChevronDown,
  Clear,
  Closed,
  Dash,
  Dashboard,
  Error,
  ErrorAuth,
  ErrorNetwork,
  ErrorServer,
  ErrorUnexpected,
  Filters,
  Gear,
  Impersonate,
  LeftArrow,
  Logo,
  NetworkError,
  Number,
  Pen,
  Percentage,
  RightArrow,
  Safe,
  Search,
  ServerError,
  SortDecremental,
  SortIncremental,
  Table,
  Tag,
  UnexpectedError,
  World,
} from "../../assets/svg";
import { Colors, Metrics } from "../../resources";
import { StyleSheet, View } from "react-native";

import React from "react";
import { SIconType } from "../../types";

interface IProps {
  type: SIconType;
  focus?: boolean;
  size?: number;
  color?: string;
  focusColor?: string;
}
const SIcon: React.FC<IProps> = ({
  type,
  focus = false,
  size = Metrics.iconSmall,
  color = Colors.blue700,
  focusColor = Colors.blue700,
}) => {
  const renderIcon = () => {
    const fill = focus ? focusColor : color;

    switch (type) {
      case SIconType.Logo: {
        return <Logo size={size} color={fill} />;
      }
      case SIconType.Dashboard: {
        return <Dashboard size={size} color={fill} />;
      }
      case SIconType.Impersonate: {
        return <Impersonate size={size} color={fill} />;
      }
      case SIconType.World: {
        return <World size={size} color={fill} />;
      }
      case SIconType.Filters: {
        return <Filters size={size} color={fill} />;
      }
      case SIconType.Search: {
        return <Search size={size} color={fill} />;
      }
      case SIconType.ChevronDown: {
        return <ChevronDown size={size} color={fill} />;
      }
      case SIconType.Check: {
        return <Check size={size} color={fill} />;
      }
      case SIconType.Error: {
        return <Error size={size} color={fill} />;
      }
      case SIconType.ErrorAuth: {
        return <ErrorAuth size={size} color={fill} />;
      }
      case SIconType.ErrorNetwork: {
        return <ErrorNetwork size={size} color={fill} />;
      }
      case SIconType.ErrorServer: {
        return <ErrorServer size={size} color={fill} />;
      }
      case SIconType.ErrorUnexpected: {
        return <ErrorUnexpected size={size} color={fill} />;
      }
      case SIconType.Chart: {
        return <Chart size={size} color={fill} />;
      }
      case SIconType.Pen: {
        return <Pen size={size} color={fill} />;
      }
      case SIconType.Tag: {
        return <Tag size={size} color={fill} />;
      }
      case SIconType.Table: {
        return <Table size={size} color={fill} />;
      }
      case SIconType.Number: {
        return <Number size={size} color={fill} />;
      }
      case SIconType.Percentage: {
        return <Percentage size={size} color={fill} />;
      }
      case SIconType.Gear: {
        return <Gear size={size} color={fill} />;
      }
      case SIconType.Safe: {
        return <Safe size={size} color={fill} />;
      }
      case SIconType.Dash: {
        return <Dash size={size} color={fill} />;
      }
      case SIconType.Closed: {
        return <Closed size={size} color={fill} />;
      }
      case SIconType.ArrowDown: {
        return <ArrowDown size={size} color={fill} />;
      }
      case SIconType.ArrowLeft: {
        return <ArrowLeft size={size} color={fill} />;
      }
      case SIconType.ArrowRight: {
        return <ArrowRight size={size} color={fill} />;
      }
      case SIconType.SortIncremental: {
        return <SortIncremental size={size} color={fill} />;
      }
      case SIconType.SortDecremental: {
        return <SortDecremental size={size} color={fill} />;
      }
      case SIconType.AuthError: {
        return <AuthError size={size} color={fill} />;
      }
      case SIconType.ServerError: {
        return <ServerError size={size} color={fill} />;
      }
      case SIconType.NetworkError: {
        return <NetworkError size={size} color={fill} />;
      }
      case SIconType.LeftArrow: {
        return <LeftArrow size={size} color={fill} />;
      }
      case SIconType.RightArrow: {
        return <RightArrow size={size} color={fill} />;
      }
      case SIconType.UnexpectedError: {
        return <UnexpectedError size={size} color={fill} />;
      }
      case SIconType.Clear: {
        return <Clear size={size} color={fill} />;
      }
      default: {
        return <View style={styles.placeholder} />;
      }
    }
  };

  return <>{renderIcon()}</>;
};

const styles = StyleSheet.create({
  placeholder: {
    width: Metrics.iconSmall,
    height: Metrics.iconSmall,
  },
});

export default SIcon;
